import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        app: {
            title: 'Sogno',
            version: '0.0.1',
            drawer: false
        },
        auth: {
            token: null,
            expiration: null
        },
        user: {
            id: null,
            firstname: null,
            lastname: null,
            email: null,
            language: null,
            gender: null,
            aims: {
                weight: null,
                date: null
            }
        },
        content: {
            weights: false,
            calories: false,
            templates: false
        }
    },
    mutations: {
        drawer (state, val) {
            state.app.drawer = val
        },
        changeLanguage (state, newlang) {
            state.user.language = newlang
        }
    },
    actions: {
    },
    modules: {
        Cookies
    }

})
